'use client'

import { useEffect } from 'react'

import { AbTestDto, abTestExposeEvent } from '@marketplace-web/shared/ab-tests-data'
import { useTracking } from '@marketplace-web/shared/event-tracker'

type Props = {
  anonId: string
  userId?: string
  countryCode: string
  abTest: AbTestDto
}

const TrackAbTestExposee = ({ anonId, userId, countryCode, abTest }: Props) => {
  const { track } = useTracking()

  useEffect(() => {
    track(abTestExposeEvent({ anonId, userId, countryCode, ...abTest }))
  }, [anonId, userId, countryCode, abTest, track])

  return null
}

export default TrackAbTestExposee
